import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: "AIzaSyC-tUnBofJn9DcfiRkts9_32X-tkkcU4sQ",
  authDomain: "bela-usaha-jakarta-27575.firebaseapp.com",
  projectId: "bela-usaha-jakarta-27575",
  storageBucket: "bela-usaha-jakarta-27575.firebasestorage.app",
  messagingSenderId: "1026812261263",
  appId: "1:1026812261263:web:d8bfff11e454de66b991fa",
  measurementId: "G-075RNN7CWJ"
};

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)